<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="1100"
    title="设备操作日志"
    alignCenter
    @close="handleClose"
  >
    <div :key="freshKey" class="device-log-content">
      <ComList
        ref="logListRef"
        :formItem="formItem"
        :buttonItem="[]"
        :tableItem="tableItem"
        :dataPro="dataPro"
        :showTenant="false"
        :enableBoxSelect="false"
      />
    </div>
  </ComDialog>
</template>

<script setup>
import { ref } from "vue";
import { ElMessage } from "element-plus";
import ComDialog from "@/components/comDialog/index.vue";
import ComList from "@/components/comList/index.vue";
import request from "@/utils/request.ts";
import API_CONFIG from "../api.json";
import { getDictData, getDictLabel } from "@/utils/index.ts";

const dialogVisible = ref(false);
const logListRef = ref(null);
const freshKey = ref(0);

// 由外层设备行注入：设备编号（必填）
const deviceCode = ref("");

const formItem = ref([
  {
    label: "操作类型",
    prop: "operateType",
    width: 120,
    type: "select",
    optionsPro: async () => await Promise.resolve(getDictData("DEVICE_LOG_OPERATE_TYPES"))
  },
  {
    label: "操作来源",
    prop: "operateSource",
    width: 120,
    type: "select",
    optionsPro: async () => await Promise.resolve(getDictData("DEVICE_OPERATE_SOURCE"))
  },
  {
    label: "操作状态",
    prop: "operateStatus",
    width: 120,
    type: "select",
    optionsPro: async() => await Promise.resolve(getDictData("DEVICE_OPERATE_STATUS"))
  },
  {
    label: "操作时间",
    prop: "operateTime",
    width: 120,
    type: "daterange",
    startPlaceholder: "开始日期",
    endPlaceholder: "结束日期"
  }
]);

const tableItem = ref([
  {
    label: "操作类型",
    prop: "operateType",
    valueFormatter: ({ value }) => getDictLabel("DEVICE_LOG_OPERATE_TYPES", value) || value
  },
  { label: "操作类型描述", prop: "operateTypeDesc" },
  {
    label: "操作来源",
    prop: "operateSource",
    valueFormatter: ({ value }) => getDictLabel("DEVICE_OPERATE_SOURCE", value) || value
  },
  {
    label: "操作状态",
    prop: "operateStatus",
    valueFormatter: ({ value }) => getDictLabel("DEVICE_OPERATE_STATUS", value) || value
  },
  { label: "操作人", prop: "operatorNo" },
  { label: "备注", prop: "remark" },
  { label: "paasTaskID", prop: "paasTaskId" },
  { label: "操作时间", prop: "createTime" }
]);

const dataPro = (pageInfo, params) => {
  const payload = {
    pageDomain: { pageNum: pageInfo.pageNum, pageSize: pageInfo.pageSize },
    deviceCode: deviceCode.value,
    operateType: params.operateType || "",
    operateSource: params.operateSource || "",
    operateStatus: params.operateStatus
  };
  if (params.operateTime && params.operateTime.length) {
    payload.startTime = params.operateTime[0];
    payload.endTime = params.operateTime[1];
  }
  return request
    .post(API_CONFIG.deviceOperateLog.url, payload)
    .then(res => {
      if (!res || (res.code != 200 && res.code != 0)) {
        ElMessage.error(res?.msg || "查询失败");
        return { list: [], total: 0 };
      }
      // 兼容扁平 { data:[], total } 与嵌套 { data:{ data:[], total } }
      const list = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];
      const total = Array.isArray(res.data)
        ? res.total || 0
        : res.data?.total || 0;
      return { list, total };
    })
    .catch(() => ({ list: [], total: 0 }));
};

// deviceCode 必填，由主页设备行带入
const open = (code) => {
  if (!code) {
    ElMessage.warning("缺少设备编号");
    return;
  }
  deviceCode.value = code;
  dialogVisible.value = true;
  freshKey.value++; // 重挂 ComList，清空上次筛选/分页，触发 onMounted 自动查询
};

const handleClose = () => {
  dialogVisible.value = false;
};

defineExpose({ open });
</script>

<style scoped>
.device-log-content {
  padding: 10px;
  height: 60vh;
}
</style>
